module.exports = __webpack_public_path__ + "img/new_accommodation.65978713.jpg";